module.exports = __webpack_public_path__ + "img/automation-icon.9f240f44.svg";